import { forwardRef, useEffect, useState } from 'react';
import styles from './textField.module.css';
import attentionIcon from 'assets/svg/attention-01.svg';
import classNames from 'classnames';

const TextField = forwardRef(
  (
    {
      className = '',
      classNameLabel = '',
      label,
      field,
      required = false,
      isFormValidate,
      errorMessage = undefined,
      hideErrorBlock = false,
      onChange = undefined,
      type = 'text',
      name = undefined,
      placeholder = 'Введите данные',
      defaultValue = undefined,
      max,
      min,
      ...rest
    },
    ref,
  ) => {
    const [inputValue, setInputValue] = useState('');

    const handleChange = (event) => {
      const inputValue = event.target.value;
      event.stopPropagation();

      if (type === 'number' && event.target.value.length !== 0) {
        const inputValueNumber = Number(event.target.value);

        if (max !== undefined && inputValueNumber > max) {
          setInputValue(max);
          onChange && onChange(max);
        } else if (min !== undefined && inputValueNumber < min) {
          setInputValue(min);
          onChange && onChange(min);
        } else {
          setInputValue(inputValueNumber);
          onChange && onChange(inputValueNumber);
        }
      } else {
        setInputValue(inputValue);
        onChange && onChange(inputValue);
      }
    };

    useEffect(() => {
      if ((field === null || field === undefined) && defaultValue !== undefined) {
        setInputValue(defaultValue);
      } else setInputValue(field);
    }, [defaultValue, field]);

    return (
      <div className={classNames(styles.textField)}>
        <div className={classNames(styles.formFieldContainer, className)}>
          <div className={classNames(styles.label, classNameLabel)}>{label}</div>
          <div className={styles.inputContainer}>
            <input
              name={name}
              className={styles.input}
              value={inputValue}
              onChange={handleChange}
              type={type}
              placeholder={placeholder}
              min={min}
              max={max}
              {...rest}
            />
          </div>
        </div>
        {!hideErrorBlock && (
          <div className={styles.dataErrorBlock}>
            {required && !field?.toString()?.trim() && isFormValidate && (
              <>
                <img src={attentionIcon} alt={'attention'} />
                <div className={styles.dataError}>
                  {errorMessage?.message || 'Поле обязательно для заполнения'}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    );
  },
);

export default TextField;
